import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';
import { AES } from 'crypto-js';
import { formatPedidoFolio } from '@/utils/pedido-folio';

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.scss']
})
export class TicketComponent {
  @Input() cssClass: string;
  @Input() idPedido: number;
  @Input() showButton: boolean = true;
  base64: any;
  @ViewChild('content') content: TemplateRef<any>;
  Pedido: any

  constructor(private modalService: NgbModal,
    private toastr: ToastrService,
    public generalService: GeneralService,
    protected sanitizer: DomSanitizer,
    public loadingService: LoadingService) {
  }

  ngOnInit() {
  }

  async open() {
    await this.getPedido();
    this.getTicket();
  }

  getTicket() {
    if (!this.idPedido) return
    this.loadingService.setLoading(true)
    this.generalService.getObtiene("documentos/ticket", this.idPedido)
      .then(res => {
        this.base64 = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.base64);
        this.modalService.open(this.content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {
        }, (reason) => {
          //Cerrasdo por X, ESC, backdrop
        });
        this.loadingService.setLoading(false)
      })
      .catch(err => {
        console.log(err)
        this.loadingService.setLoading(false)
      })
  }

  async getPedido() {
    try {
      let res = await this.generalService.getObtiene("pedido", this.idPedido)
      this.Pedido = res.data;
    } catch (error) {
      this.Pedido = null
    }
  }


  enviarWsp() {
    const clave = 'V0ugwk04DfHD7'; // Asegúrate de utilizar una clave segura
    const parametroEncriptado = AES.encrypt(`idPedido:${this.idPedido}`, clave).toString();
    const parametroCodificado = encodeURIComponent(parametroEncriptado.replace(/\//g, '_'));

    const link = `${window.location.protocol}//${window.location.hostname}/detalle/${parametroCodificado}`

    const folio = formatPedidoFolio(this.Pedido);
    const mensaje = `${this.Pedido.cliente.nombre_completo}, se ha generado el pedido ${folio}, haz click en el siguiente enlace para ver el detalle: ${link}`

    window.open(`https://api.whatsapp.com/send?phone=${this.Pedido.cliente.telefono.replace(/[+]/g, '')}&text=${mensaje}`, '_blank');

  }


  enviarMail() {
    this.loadingService.setLoading(true);
    const clave = 'V0ugwk04DfHD7'; // Asegúrate de utilizar una clave segura
    const parametroEncriptado = AES.encrypt(`idPedido:${this.idPedido}`, clave).toString();
    const parametroCodificado = encodeURIComponent(parametroEncriptado.replace(/\//g, '_'));

    const link = `${window.location.protocol}//${window.location.hostname}/detalle/${parametroCodificado}`
    const folio = formatPedidoFolio(this.Pedido);

    const body = {
      "to": this.Pedido.cliente.email,
      "subject": `Creacion Ticket ${folio}`,
      "nombre_cliente": this.Pedido.cliente.nombre_completo,
      "id_pedido": folio,
      "url_ticket": link
    }

    this.generalService.postCrear("mail/sendTicket", body)
      .then(async res => {
        this.toastr.success('Correo enviado exitosamente!');
        this.loadingService.setLoading(false);
      })
      .catch(err => {
        this.toastr.error('Error al enviar correo!');
        this.loadingService.setLoading(false);
      });


  }

}
